import React from "react";
import { Box, Button, Grid, Sheet, Stack } from "@mui/joy";
import { theme } from "../../styles/theme";
import { KeypadDeleteIconSvg } from "../../static/image/common/SvgAssets";

type NumericKeypadProps = {
  onInput: (digit: string) => void;
  onBackspace: () => void;
  onClear?: () => void;
  disabled?: boolean;
};

export const Dots: React.FC<{ count: number }> = ({ count }) => {
  return (
    <Stack
      direction="row"
      spacing={"20px"}
      justifyContent="center"
      alignItems="center"
    >
      {Array.from({ length: 4 }).map((_, idx) => (
        <Box
          key={idx}
          sx={{
            width: "16px",
            height: "16px",
            borderRadius: "50%",
            boxShadow: `inset 0 0 0 2px ${idx < count ? theme.vars.palette.Content.Strong : theme.vars.palette.Content.SuperWeak}`,
            backgroundColor:
              idx < count ? theme.vars.palette.Content.Strong : "transparent",
          }}
        />
      ))}
    </Stack>
  );
};

const KeyButton: React.FC<{
  label: React.ReactNode;
  onClick: () => void;
  disabled?: boolean;
}> = ({ label, onClick, disabled }) => (
  <Button
    fullWidth
    variant="Plain"
    color="neutral"
    size="md"
    onClick={onClick}
    disabled={disabled}
    sx={{
      alignItems: "center",
      backgroundColor: theme.vars.palette.Background.Level1,
      color: theme.vars.palette.Content.Strong,
      height: 56,
      fontSize: 22,
      fontWeight: 590,

      "@media (min-width: 1024px)": {
        "&:hover": {
          backgroundImage: "none",
        },
      },
      "@media (max-width: 1024px)": {
        "&:hover": {
          backgroundColor: theme.vars.palette.Background.Level1,
          color: theme.vars.palette.Content.Strong,
        },
      },

      // 포커스 상태를 기본 상태와 동일하게 유지
      "&:focus": {
        backgroundColor: theme.vars.palette.Background.Level1,
        color: theme.vars.palette.Content.Strong,
      },
      // 클릭(터치)하는 순간 (비활성화 상태가 아닐 때만)
      "&:not(.Mui-disabled):active": {
        backgroundImage: "none",
      },
    }}
  >
    {label}
  </Button>
);

const NumericKeypad: React.FC<NumericKeypadProps> = ({
  onInput,
  onBackspace,
  onClear,
  disabled,
}) => {
  return (
    <Sheet
      variant="soft"
      sx={{
        backgroundColor: theme.vars.palette.Background.Level1,
      }}
    >
      <Grid container spacing={1}>
        {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
          <Grid xs={4} key={n}>
            <KeyButton
              label={String(n)}
              onClick={() => onInput(String(n))}
              disabled={disabled}
            />
          </Grid>
        ))}
        <Grid xs={4}></Grid>
        <Grid xs={4}>
          <KeyButton
            label="0"
            onClick={() => onInput("0")}
            disabled={disabled}
          />
        </Grid>
        <Grid xs={4}>
          <KeyButton
            label={<KeypadDeleteIconSvg />}
            onClick={onBackspace}
            disabled={disabled}
          />
        </Grid>
      </Grid>
      <Box sx={{ height: 4 }} />
    </Sheet>
  );
};

export default NumericKeypad;
